module.exports = __webpack_public_path__ + "static/media/user.282699e2.svg";